// The APK on the sign-in and sign-up pages, for an Android phone: someone who
// dismissed the app prompt can still get the app, without an account. An
// iPhone can't install it, so it sees nothing here.
import React from "react";
import { ANDROID_APK_URL, isAndroid, isMobileDevice } from "../MobileAppPromptModal";

export default function AndroidAppLink() {
  if (!isMobileDevice() || !isAndroid()) return null;
  return (
    <a href={ANDROID_APK_URL} rel="noopener" className="text-center type-label text-accent-default hover:text-accent-hover">
      Get the Android app
    </a>
  );
}
